<template>
  <nuxt-link
    v-if="productVariant && productRoute"
    :to="productRoute"
    class="flex flex-col justify-end h-full relative"
    tabindex="-1"
  >
    <div v-if="showBadges">
      <SaleBadgeIcon v-if="onSale" class="absolute h-1/3 sm:h-1/4 md:h-1/3 ml-2 sm:ml-4 z-10 top-4" />
      <div v-else-if="newBadge">
        <NewBadgeIcon class="absolute h-1/3 sm:h-1/4 md:h-1/3 ml-2 sm:ml-4 z-10 sm:top-4 -top-4" />
      </div>
    </div>
    <div class="sm:mx-10 h-full flex items-center">
      <CldnImg
        v-if="productVariant.image"
        :src="productVariant.image.src"
        :alt="productVariant.image.altText ? productVariant.image.altText : productVariant.title"
        crop="fill"
        sizes="50vw sm:50vw lg:30vw xl:325px"
        class="variant-image"
      />
    </div>
  </nuxt-link>
</template>

<script>
import CldnImg from '@/components/CldnImg';
import SaleBadgeIcon from '@/components/icons/SaleBadgeIcon';
import NewBadgeIcon from '@/components/icons/NewBadgeIcon';

export default defineNuxtComponent({
  name: 'ProductCardVariantImg',

  components: { CldnImg, SaleBadgeIcon, NewBadgeIcon },

  props: {
    productVariant: {
      type: Object,
      default: () => null,
    },
    productRoute: {
      type: Object,
      default: () => null,
    },
    newBadge: {
      type: Boolean,
      default: false,
    },
    showBadges: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    onSale() {
      if (this.productVariant.compareAtPrice) {
        return +this.productVariant?.price?.amount < +this.productVariant?.compareAtPrice?.amount;
      }
      return false;
    },
  },
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
.variant-image {
  @apply select-none h-full sm:h-auto mx-auto;
}
</style>
